import * as React from "react"
import { CSVLink } from "react-csv"
import { CloudDownload } from "@walmart-web/livingdesign-icons"
import { FormattedMessage } from "react-intl"
import Button from "../Button"
import "./ExportCSV.scss"

type ExportCSVProps = {
	fileName: string
	data: object[]
	name?: string
	align?: "right"
}

const ExportCSV: React.FC<ExportCSVProps> = (props) => {
	const { data, fileName, name, align = "left" } = props
	return (
		<div className={`cvs-link-container ${align}`}>
			<CSVLink data={data} title={fileName} separator=";" filename={fileName}>
				<Button
					variant="secondary"
					leading={<CloudDownload />}
					UNSAFE_className={name ?? "only-icon"}
				>
					{name && <FormattedMessage id={name} />}
				</Button>
			</CSVLink>
		</div>
	)
}

export default ExportCSV
